// PlugVue identity, storage key, device operations, status keys and section layout
export const PV_TARGET_ALL = 'all';
export const PV_PIN_KEY = 'plugVue.pinned';

export const PV_OPS = {
    switch: 'SetSwitch',
    led: 'SetLed',
};

export const PV_STATUS = {
    on: 'on',
    off: 'off',
    offline: 'offline',
};

// sections come from BE (getSections), plugs with an empty/unknown section land here, always last
export const PV_SECTION_FALLBACK = 'Other';

// Drawing toggle hides plugs at or below this power
export const PV_DRAW_MIN_W = 1;

export const PV_ROW_KIND = {
    plug: 'plug',
    untracked: 'untracked',
};
